export type DashboardRole = "admin" | "doctor" | "frontdesk" | "nursing" | "default";

const ROLE_PRIORITY: { spatie: string; dash: DashboardRole }[] = [
  { spatie: "admin", dash: "admin" },
  { spatie: "developer", dash: "admin" },
  { spatie: "manager", dash: "admin" },
  { spatie: "doctor", dash: "doctor" },
  { spatie: "nurse", dash: "nursing" },
  { spatie: "receptionist", dash: "frontdesk" },
];

export function getTopDashboardRole(): DashboardRole {
  try {
    const user = JSON.parse(window.localStorage.getItem("user") || "{}");
    const roles: { name: string }[] = user?.roles ?? [];
    const roleNames = roles.map((r) => r.name?.toLowerCase());

    for (const { spatie, dash } of ROLE_PRIORITY) {
      if (roleNames.includes(spatie)) return dash;
    }
  } catch {
    // ignore parse errors
  }
  return "default";
}
